/**
 * Lightweight analytics helper. Forwards events to Google Analytics 4
 * (`window.gtag`) and Mixpanel (`window.mixpanel`) when they are loaded
 * via script tag or env-var-driven snippet. Silently no-ops otherwise
 * so we never break the app when scripts aren't present.
 *
 * To enable:
 *  - GA4: add the gtag.js script to public/index.html (or load it
 *    dynamically) using your G-XXXX measurement id.
 *  - Mixpanel: add the mixpanel-browser snippet and call
 *    window.mixpanel.init(TOKEN).
 *
 * Usage:
 *   import { track } from '@/lib/analytics';
 *   track('appointment_request_submit', { treatment: 'Dental Implants' });
 */

const isClient = typeof window !== 'undefined';

export const track = (event, props = {}) => {
  if (!isClient) return;

  // Google Analytics 4
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, props);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[analytics] gtag failed', err);
  }

  // Mixpanel
  try {
    if (window.mixpanel && typeof window.mixpanel.track === 'function') {
      window.mixpanel.track(event, props);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[analytics] mixpanel failed', err);
  }

  // Dev visibility — keep so failed integrations are observable
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.info('[analytics]', event, props);
  }
};

export const trackPageView = (path) => {
  track('page_view', { page_path: path });
};
